import React from 'react';

interface LegalSectionProps {
  number: number;
  title: string;
  children: React.ReactNode;
}

const LegalSection: React.FC<LegalSectionProps> = ({ number, title, children }) => (
  <div className="legal-section mb-10">
    <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-4">
      <span className="bg-primary-500/20 text-primary-400 w-9 h-9 rounded-full flex items-center justify-center text-base font-bold border-2 border-primary-500/50 shrink-0">
        {number}
      </span>
      {title}
    </h2>
    <div className="pl-13">{children}</div>
  </div>
);

export default LegalSection;
